import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  type User,
} from "firebase/auth";
import { auth } from "./firebaseConfig";

/**
 * メールアドレス・パスワードでログインする。
 * サインアップ機能は実装しない(architecture.md契約上、UIDは事前にFirebaseコンソールで
 * 手動作成されている想定のため)。
 */
export async function login(email: string, password: string): Promise<void> {
  await signInWithEmailAndPassword(auth, email, password);
}

export async function logout(): Promise<void> {
  await signOut(auth);
}

export function watchAuthState(callback: (user: User | null) => void): () => void {
  return onAuthStateChanged(auth, callback);
}

/**
 * Firestore/Worker呼び出し用のIDトークンを取得する。
 * forceRefresh=true にすると期限切れ間近のトークンでも確実に更新される。
 */
export async function getCurrentIdToken(forceRefresh = false): Promise<string> {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("not_authenticated");
  }
  return user.getIdToken(forceRefresh);
}
